<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Discount Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column is-4">
                    <b-field label="Discount Code" label-position="inside">
                        <b-input v-model="discount.code" maxlength="20"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="discount.title" maxlength="200"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Discount Type" label-position="inside">
                        <b-select v-model="discount.type" expanded>
                            <option value="amount">Discounted by Dollar Amount</option>
                            <option value="percent">Discounted by Percent Amount</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Amount" label-position="inside">
                        <b-input v-model="discount.value" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'RmcDiscountForm',
        props: {
            discount: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };
</script>
